/*
Sohel 09/19/2022 3075154998 Data Manager Matching Logic ->Integrated API,Added System Notes and Suggested Changes
Suresh Peddavoora 10/26/2022 3075154998  Added Class Name for Table Enhancements
akhila 11/01/2022 3075154998 TablePagination bugFix
saikrishna 11/03/2022 3075154998 changed the paginationOptions
Lalitha 11/10/2022 3075154998 Added title Created by in table and arrange table
*/
import React, {createRef, useState, useEffect} from 'react';
// import MaterialTable from "material-table";
import {TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../../../components/TableIcons';
import {httpPaginationPost} from '../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {defaultRows} from '../../../../../constants/ReusableTablePagination';
import {Button} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import DialogBox from '../../../../../components/DialogBox';
import {postSystemNotes, ResetMessage as resetMessage} from '../../../../../redux/reducers/DMMatchingLogic';
import AddUserDefinedNotes from '../../../../../components/AddUserDefinedNotes';
import {ErrorSnackbar, SuccessSnackbar} from './../../../../../components/CustomSnackBar/index';
import GuiTable from '../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../constants/ReusableConstants';

export default function MatchingLogicSystemNotes({matchingLogicCode}) {
  const moment = require('moment-timezone');
  const columns = [
    {
      title: 'Matching Logic Code',
      field: 'filterCode',
      render: (rowData) => <>{rowData?.code}</>,
    },
    {
      title: 'Note Date & Time',
      field: 'noteDate',
      type: 'datetime',
      dateSetting: {locale: 'en-US'},
      render: (rowData) => (
        <>
          {rowData?.noteDate && moment(rowData.noteDate).format('MM/DD/YYYY')}
          {` `}
          {rowData?.noteTime && moment(rowData.noteTime, 'HH:mm').format('hh:mm A')}
        </>
      ),
    },
    {
      title: 'Note Text',
      field: 'noteText',
      cellStyle: {
        minWidth: '550px',
        wordBreak: 'break-word',
      },
      render: (rowData) => <span style={{whiteSpace: 'pre-wrap'}}>{rowData.noteText}</span>,
    },
    {
      title: 'Created by',
      field: 'userId',
    },
    {
      title: 'Note Type',
      field: 'noteType',
    },
  ];

  const dispatch = useDispatch();
  const [arrayLast, setArrayLast] = useState(false);
  const [rows, setRows] = useState(defaultRows);
  let transcription = '';
  const tableRef = createRef();
  const [charLimitMsg, setCharLimitMsg] = useState(false);
  const [webSocketOnClose, setWebSocketOnClose] = useState();
  const [isAddaNoteDialogOpen, setAddaNoteDialogOpen] = useState(false);
  const handleDialogClose = () => {
    stop(webSocketOnClose);
    transcription = '';
    setAddaNoteDialogOpen(false);
  };
  const handleSelectedNotesOption = () => {
    setAddaNoteDialogOpen(true);
  };
  const {isSystemNoteLoading, systemNotesStatus, notesuccessMsg, errorMsg} = useSelector(
    ({dMMatchingLogic}) => dMMatchingLogic,
  );
  useEffect(() => {
    if (systemNotesStatus === 200) {
      tableRef.current.onQueryChange();
      handleDialogClose();
      setTimeout(() => {
        dispatch(resetMessage());
      }, 3000);
    }
  }, [systemNotesStatus]);

  const dispatchRecordFormatSystemNotes = (data) => {
    if (data) {
      dispatch(
        postSystemNotes({
          code: matchingLogicCode ? matchingLogicCode : '',
          noteText: data,
        }),
      );
    }
  };
  useEffect(() => {
    if (errorMsg || notesuccessMsg) {
      setTimeout(() => {
        resetMessage();
      }, 2500);
    }
  }, [errorMsg, notesuccessMsg]);
  return (
    <>
      <div className="custom-table global-field-table">
        <DialogBox
          title="User Defined Notes"
          button2Text="Save"
          button1Text="Cancel"
          open={isAddaNoteDialogOpen}
          dialogClose={handleDialogClose}
          maxWidth={'md'}
        >
          {isAddaNoteDialogOpen && (
            <AddUserDefinedNotes
              transcription={transcription}
              setWebSocketOnClose={setWebSocketOnClose}
              charLimitMsg={charLimitMsg}
              isLoading={isSystemNoteLoading}
              setCharLimitMsg={setCharLimitMsg}
              dispatchRecordFormatSystemNotes={dispatchRecordFormatSystemNotes}
            />
          )}
        </DialogBox>
        <GuiTable
          title=""
          columns={columns}
          icons={tableIcons}
          tableRef={tableRef}
          data={(query) =>
            new Promise((resolve) => {
              const url = `matchinglogic/find/all/matchinglogicnotes`;
              const bodyObj = {
                code: matchingLogicCode,
                limit: rows,
                orderBy: '',
                orderDirection: '',
                search: '',
                page:
                  arrayLast && query.page >= 1 ?
                    query.page :
                    arrayLast ?
                      (query.page <= 1 && query.page + 1) || query.page - 1 :
                      query.page + 1,
              };
              if (!matchingLogicCode) {
                resolve({
                  data: [],
                  page: 0,
                  totalCount: 5,
                });
              } else {
                httpPaginationPost(url, bodyObj)
                  .then((response) => {
                    if (response?.status === 200) {
                      const data = response.data.response.resultObjects;
                      resolve({
                        data: data.length > 0 ? data : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setArrayLast(response.data.response.resultObjects.length === 1);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                  .catch((response) => {
                    resolve({
                      data: [],
                      page: 0,
                      totalCount: 5,
                    });
                    dispatch({
                      type: 'FETCH_ERROR',
                      payload: response && response.message ? response.message : null,
                    });
                  });
              }
            })
          }
          options={{
            search: false,
            pageSize: rows,
            toolbar: true,
            showSelectAllCheckbox: false,
            emptyRowsWhenPaging: false,
            pageSizeOptions: tablePageRows,
            headerStyle: {
              fontWeight: 'bold',
            },
          }}
          components={{
            Pagination: (props) => (
              <div className="global-field-table-footer ">
                <div className="mt-2">

                </div>
                <div className="w-50" style={{backgroundColor: 'white', border: '0px'}}>
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              </div>
            ),
          }}
          actions={[
            {
              icon: () => (
                <div>
                  <Button variant="outlined" className="search-btn">
                    <AddIcon /> Add
                  </Button>
                </div>
              ),
              isFreeAction: true,
              onClick: () => handleSelectedNotesOption(),
            },
          ]}
        />
      </div>
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {notesuccessMsg && <SuccessSnackbar successMsg={notesuccessMsg} />}
    </>
  );
}
